
import { getMarketingInfoImgs } from '@/models/home'
const state = {}
const mutations = {}
export const actions = {
    async getMarketingInfoImgs ({ commit }, params) {
        params = {
            marketing_id: params
        }
        const data = await getMarketingInfoImgs(params)
        return data
    },
}
export const getters = {}
export default {
    state,
    mutations,
}
